import { Singleton } from 'typescript-ioc'
import { APIClientBase } from './APIClientBase'

@Singleton
export class ConsigneeAPIClient extends APIClientBase {
  /**
   * Instanciate api client
   */
  constructor () {
    super('consignee')
  }
}
